import { render, staticRenderFns } from "./PrecosPromocionais.vue?vue&type=template&id=2d3fc9ec"
import script from "./PrecosPromocionais.vue?vue&type=script&lang=js"
export * from "./PrecosPromocionais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports